module.exports = __webpack_public_path__ + "img/features-split-top-01.c26b1b01.png";